import React from 'react';
import Text from 'components/core/Text';
import { ContextChip, Question, Tone } from './styles';

type Props = {
  title: string;
  instruction: string;
  context?: string;
  tone?: Tone;
};

const QuestionHeader = ({ title, instruction, context, tone = 'light' }: Props) =>
  tone === 'dark' ? (
    <Question $tone="dark">
      {context && (
        <Text variant="captionSmall" color="grayLight">
          {context}
        </Text>
      )}
      <Text variant="sectionHeader" tag="h2" color="white" transform="uppercase">
        {title}
      </Text>
      <Text tag="p" color="white">
        {instruction}
      </Text>
    </Question>
  ) : (
    <Question>
      {context && <ContextChip>{context}</ContextChip>}
      <Text variant="displayM" tag="h2" color="black" transform="none">
        {title}
      </Text>
      <Text variant="textSmall" color="gray">
        {instruction}
      </Text>
    </Question>
  );

export default QuestionHeader;
